const state = {
    // ---------------------- 浏览器标签页 -------------------------
    tab: {
        name: '1+X证书考试系统',        // 名称，原：1+X证书考试系统
        icon: '',                      // 图标（为空则按照public下的ico文件）
    },

    // ---------------------- 网站所有页面 -------------------------
    page: {
        name: '1+X证书考试系统',        // 名称，原：1+X证书考试系统
        icon: '',                      // 图标（为空则按照原设计）
    },

    // ------------------------- 登录页----------------------------
    login: {
        title: '考生登录',             // 登录页标题，原：考生登录
        accountLabel: '准考证号',      // 账号名称字段，原：准考证号
        backgroundImg: '',            // 背景图（为空则按照原设计）
        backgroundWaves: true,        // 背景波浪是否显示
    },

    // ------------------------ 考试模块 --------------------------
    examModule: {
        typeKeyword: '考试',           // 替换所有考试关键字，原：考试
        stuKeyword: '考生',            // 替换所有考生关键字，原：考生
        backgroundImg: '',             // 考生确认页、考生等待页、实训环境加载页的背景图（为空则按照原设计）
        backgroundWaves: true,         // 考生确认页、考生等待页、实训环境加载页的背景波浪是否显示

    // --------------------- 考生信息确认页-------------------------
        showInfoConfirmation: true,    // true：显示考生信息确认页；false：不显示考生信息确认页，提前登录则进入等待页面

    // --------------------- 考试页、实训页-------------------------
        remainingTime: '考试剩余时间',  // 剩余时间名称，原：考试剩余时间
    // --------------------- 考试结束页-------------------------
        endTip: true,                  // 是否显示考试结束提示语，原：true
    },
    externalLink: [],
}

export default {
    state,
}
